import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "../ui/dialog";
import InquiryForm from "./InquiryForm";
import { useState } from "react";

const ApplyDialog = ({ trigger, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="sm:max-w-[520px] p-0 overflow-hidden border-0 bg-transparent shadow-none" data-testid="apply-dialog">
        <div className="bg-white rounded-3xl overflow-hidden">
          <div className="bg-gradient-to-r from-megha-primary to-megha-accent px-6 py-5 text-white">
            <DialogHeader>
              <DialogTitle className="text-xl font-heading font-extrabold">B.Tech Admissions 2026</DialogTitle>
              <DialogDescription className="text-blue-50/90 text-sm">
                Tell us about yourself — we'll reach out with your seat options & scholarship eligibility.
              </DialogDescription>
            </DialogHeader>
          </div>
          <div className="p-4 md:p-6">
            <InquiryForm variant="solid" showMessage onSuccess={() => setOpen(false)} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ApplyDialog;
